import Sortable from 'sortablejs'

export default {
  install (Vue) {
    Vue.directive('DSortable', function (arr = []) {
      if (this.el.sortable) {
        this.el.sortable.destroy()
      }
      let config = {}
      config.onUpdate = (e) => {
        let target = arr[e.oldIndex]
        arr.$remove(target)
        arr.splice(e.newIndex, 0, target)
      }

      this.el.sortable = Sortable.create(this.el, config)
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/directives/v-sortable.js
 **/